import React from 'react'

function TableHead() {
    return <thead className="TableHead">
    <tr>
        <th className="queueId">Ngày</th>
        <th className="queueName">Số tiền</th>
        <th className="waitingCall text-center">Loại thanh toán</th>
        <th className="availAgent text-center">Trạng thái thanh toán</th>
        <th className="unAvailAgent text-center">Số dư</th>
    </tr>
    </thead>
}

export default TableHead
